import { Pipe, PipeTransform } from '@angular/core';

export function translateCut(value: string, cutIndex: number): string {
    const cuts = value.split('|');
    return cutIndex < cuts.length ? cuts[cutIndex] : '';
}

@Pipe({ name: 'translateCut' })
export class TranslateCutPipe implements PipeTransform {
    transform(value: string, cutIndex: number): string {
        return translateCut(value, cutIndex);
    }
}
